module.exports = __webpack_public_path__ + "static/media/1350_ItemSelection_GiftShop_step3.b6b3ae57.png";